const notificationDropdown = {
  title: "Notifications",
  loading: "Loading notifications...",
  loadFailed: "Failed to load notifications",
  empty: "No notifications",
  markAllAsRead: "Mark all as read",
  viewAll: "View all",
  viewAllNotifications: "View all notifications",
};

export default notificationDropdown;
